// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as QueryString from "../../primitives/QueryString.res.js";

let baseRoute = "/customers";

function isCustomerRoute(pathname) {
  return pathname.startsWith(baseRoute);
}

function encoder(param) {
  return param.business;
}

function decoder(business) {
  return {
    TAG: "Ok",
    _0: {
      business: business
    }
  };
}

let value = JsonCodec.object1(encoder, decoder, JsonCodec.field("business", JsonCodec.bool));

let CreateCustomerQueryStringCodecs = {
  encoder: encoder,
  decoder: decoder,
  value: value
};

function encodeCreateCustomerQueryString(state) {
  return QueryString.stringify(JsonCodec.encodeWith(state, value));
}

function decodeCreateCustomerQueryString(query) {
  let match = JsonCodec.decodeWith(QueryString.parse(query), value);
  if (match.TAG === "Ok") {
    return match._0.business;
  }
}

function encoder$1(param) {
  return param.siret;
}

function decoder$1(siret) {
  return {
    TAG: "Ok",
    _0: {
      siret: siret
    }
  };
}

let value$1 = JsonCodec.object1(encoder$1, decoder$1, JsonCodec.field("siret", JsonCodec.string));

let EditCustomerQueryStringCodecs = {
  encoder: encoder$1,
  decoder: decoder$1,
  value: value$1
};

function encodeEditCustomerQueryString(state) {
  return QueryString.stringify(JsonCodec.encodeWith(state, value$1));
}

function decodeEditCustomerQueryString(query) {
  let match = JsonCodec.decodeWith(QueryString.parse(query), value$1);
  if (match.TAG === "Ok") {
    return match._0.siret;
  }
}

let values = [
  "Information",
  "Addresses",
  "Misc"
];

function toString(value) {
  switch (value) {
    case "Information" :
      return "information";
    case "Addresses" :
      return "addresses";
    case "Misc" :
      return "misc";
  }
}

function fromString(value) {
  return values.find(section => toString(section) === value);
}

let EditSection = {
  values: values,
  toString: toString,
  fromString: fromString
};

function showRoute(id) {
  return baseRoute + "/" + id;
}

function newRoute(businessOpt, param) {
  let business = businessOpt !== undefined ? businessOpt : false;
  return baseRoute + "/new" + (
    business ? "?" + encodeCreateCustomerQueryString({
        business: business
      }) : ""
  );
}

function editRoute(id, siret) {
  return showRoute(id) + "/edit" + (
    siret !== undefined ? "?" + encodeEditCustomerQueryString({
        siret: siret
      }) : ""
  );
}

function editSectionRoute(id, section) {
  return editRoute(id, undefined) + "/" + toString(section);
}

function loyaltyHistoryRoute(id) {
  return showRoute(id) + "/loyalty-history";
}

export {
  baseRoute,
  isCustomerRoute,
  CreateCustomerQueryStringCodecs,
  encodeCreateCustomerQueryString,
  decodeCreateCustomerQueryString,
  EditCustomerQueryStringCodecs,
  encodeEditCustomerQueryString,
  decodeEditCustomerQueryString,
  EditSection,
  showRoute,
  newRoute,
  editRoute,
  editSectionRoute,
  loyaltyHistoryRoute,
}
/* value Not a pure module */
